const translationOfErrors = {
  1608: 'initialDateNotFound',
  1609: 'finalDateNotFound',
  1610: 'invalidInitialDate',
  1611: 'invalidFinalDate',
  1612: 'dateGreaterThanToday',
  1613: 'initialDateGreaterThanFinalDate',
};

export default translationOfErrors;
